/* global confirm */

import React from 'react'
import css from './styles.css'
import { connect } from 'react-redux'
import * as actions from '../../actions/settings'
import * as userActions from '../../actions/current-user'
import * as jewelryActions from '../../actions/jewelry-search'
import * as cartActions from '../../actions/cart'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.settings
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // when logout, chain up the following two actions:
    // 1). reset the jewellery questionnaire form, so that all the jewelery panel snapshots got flush out
    // 2). reseting the redux state including the current user
    logout: () => {
      if (confirmLogout()) {
        Promise.resolve(
          dispatch(jewelryActions.reset())
        ).then(function () {
          dispatch(userActions.logout())
        })
      }
    },
    // when start a new session, chain up the following two actions:
    // 1). reset the jewellery questionnaire form, so that all the jewelery panel snapshots got flush out
    // 2). start start a new session by reseting the redux state except for the current user
    newSession: () => {
      if (confirmNewSession()) {
        Promise.resolve(
          dispatch(jewelryActions.reset())
        ).then(function () {
          dispatch(cartActions.setDepositRates())
        }).then(function () {
          dispatch(userActions.newSession())
        })
      }
    },
    showPreferences: () => {
      dispatch(actions.showPreferences())
    }
  }
}

const confirmNewSession = () => confirm('Starting a new session will delete any current selections. Are you sure you would like to proceed?')

const confirmLogout = () => confirm('Logging out will delete any current selections. Are you sure you would like to proceed?')

const Menu = props => {
  return (
    <div className={css.dropdownMenu}>
      <ul>
        <li onClick={() => props.showPreferences()}>Preferences</li>
        <li onClick={() => props.newSession()}>New Session</li>
        <li onClick={() => props.logout()}>Logout</li>
      </ul>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/menu/index.js